import { HomeConfig } from './home/homeConfig';
import { PolicyConfig } from './policy/policyConfig';
import { TestConfig } from './test/testConfig';

export const mainConfig = [HomeConfig, PolicyConfig, TestConfig];
